import apiRequest from './api-request';

const resource = 'feedback';

// eslint-disable-next-line import/prefer-default-export
export function getFeedback() {
    return apiRequest({
        method: 'GET',
        resource
    });
}

export function setFeedbackIsHandled(ids: number[], isHandled: boolean) {
    return apiRequest({
        method: 'PUT',
        resource: `${resource}/set-is-handled`,
        body: { ids, isHandled }
    });
}
